// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__dyih8","active":"Modal_active__FmkGN","content":"Modal_content__yAI-j","close":"Modal_close__KD3hA"};